import { Record } from 'immutable';

export default Record({
    active: null,
    allowExclusiveCampaigns: false,
    annual: false,
    biannual: false,
    boosts: null,
    campaigns: null,
    ccFeePercentage: null,
    chat: false,
    deepWords: null,
    followups: false,
    keywordDepth: null,
    keywordLimit: null,
    keywords: null,
    landingPagesEnabled: null,
    minimumDiscountPercentage: null,
    minimumRebatePercentage: null,
    monitorListings: null,
    name: null,
    peekWords: null,
    planId: null,
    platform: null,
    price: null,
    pricePerActionRebate: 10,
    pricePerAppSurveyActionRebate: 10,
    pricePerAZSurveyActionRebate: 4.95,
    pricePerBoost: 39,
    pricePerBotRebate: 1.5,
    pricePerImageActionRebate: 10,
    pricePerProAZSurveyActionRebate: 10,
    pricePerProImageActionRebate: 20,
    pricePerProResearchActionRebate: 5,
    pricePerProShareActionRebate: 20,
    pricePerProSurveyActionRebate: 5,
    pricePerProSurveyReviewActionRebate: 5,
    pricePerProTestimonialActionRebate: 20,
    pricePerProVideoActionRebate: 30,
    pricePerRebate: 2.95,
    pricePerResearchActionRebate: 2,
    pricePerRewardRebate: 1.5,
    pricePerShareActionRebate: 10,
    pricePerSnag: 1.5,
    pricePerSurveyActionRebate: 10,
    pricePerTestimonialActionRebate: 10,
    pricePerVideoActionRebate: 10,
    purchasable: null,
    rebates: null,
    reverseAsin: null,
    videos: null,
}, 'Plan');
